import { useQueryClient } from '@tanstack/react-query'
import { ApiResponse } from '../../../types/api'

import { UserUpdateWrongRequest } from '../../../types/user'
import { useApiPostMutation } from '../useApi'

export const useUserUpdateWrong = () => {
  const queryClient = useQueryClient()
  const mutation = useApiPostMutation<ApiResponse, UserUpdateWrongRequest>()

  return {
    ...mutation,
    mutateAsync: async (data: UserUpdateWrongRequest) => {
      const result = await mutation.mutateAsync({
        url: '/user/updateWrong',
        data,
      })

      queryClient.invalidateQueries({ queryKey: ['userWrong'] })

      return result
    },
    mutate: (data: UserUpdateWrongRequest) => {
      mutation.mutate(
        {
          url: '/user/updateWrong',
          data,
        },
        {
          onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['userWrong'] })
          },
        }
      )
    },
  }
}
